jQuery(document).ready(function () {
    var $ = jQuery;

    function generateRandomString(length) {
        var result = "";
        var characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * characters.length)
            );
        }
        return result;
    }

    $(".galerie-slider").slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $(".compareslider").slick({
        variableWidth: true,
        dots: true, //
        initialSlide: 2,
        infinite: true,
        swipe: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        appendArrows: false, // $('.compareslider+.slidernavigationcontainer .slidernavigation .slidernavbuttons'),
        responsive: [
            /* {
                     breakpoint: 480,
                     settings: {
                       slidesToShow: 1,
                       slidesToScroll: 1,
                     },
                   }, */
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });
    /*
      $('.compareslider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    
        var newSlideVal = nextSlide+1;
    
        $('.slidernumber .activeSlide').html(newSlideVal);
        
      }); */

    $(".compareslider").on(
        "click",
        ".slick-slide:not(.slick-current)",
        function () {
            var newActive = $(this).data("slick-index");

            if (newActive % 2 == 0) {
                newActive = 2;
            } else {
                newActive = 1;
            }
            $(".compareslider").slick("slickGoTo", newActive);
        }
    );

    // Angebote Slider
    const angeboteOptions = getSliderOptions($(".angeboteSlider"));
    $(".angeboteSlider").slick({
        dots: false,
        infinite: true,
        adaptiveHeight: false,
        arrows: angeboteOptions.arrows,
        speed: 300,
        autoplay: angeboteOptions.autoplay,
        autoplaySpeed: angeboteOptions.autoplaySpeed,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "40px",
        responsive: [
            {
                breakpoint: 1280,
                centerMode: false,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 880,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    if ($(".angeboteSlider .angebotOuterContainer").length) {
        $(".angeboteSlider").attr("data-minelheight", 0).data("minelheight", 0);
        var currentSize = $(".angeboteSlider").data("minelheight");
        var countedchanges = 0;
        $(".angeboteSlider .angebotOuterContainer").each(function () {
            var newHeight = $(this).height();
            if (parseInt(newHeight) > parseInt(currentSize)) {
                currentSize = newHeight;
                $(".angeboteSlider")
                    .attr("data-minelheight", newHeight)
                    .data("minelheight", newHeight);
                countedchanges++;
            }
        });

        $(".angeboteSlider .angebotOuterContainer .angebotContainer").each(
            function () {
                $(this).css("min-height", currentSize - 60 + "px");
            }
        );
        console.log(
            "my new min angebotheight is: " +
            currentSize +
            " needed " +
            countedchanges +
            " recalculations "
        );
    }

    // Anwendungen Slider
    const anwendungenOptions = getSliderOptions($(".anwendungen_slider"));
    $(".anwendungen_slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        autoplay: anwendungenOptions.autoplay,
        autoplaySpeed: anwendungenOptions.autoplaySpeed,
        arrows: anwendungenOptions.arrows,
        slidesToShow: anwendungenOptions.slidesToShow,
        slidesToScroll: 1,
        centerPadding: "40px",
        responsive: [
            {
                breakpoint: 1380,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    const testimonialSliderOptions = getSliderOptions($(".testimonials_slider"));

    $(".testimonials_slider").slick({
        dots: true,
        arrows: testimonialSliderOptions.arrows,
        infinite: true,
        speed: 300,
        autoplay: testimonialSliderOptions.autoplay,
        autoplaySpeed: testimonialSliderOptions.autoplaySpeed,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1220,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 870,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    // Referenzen Slider
    const refOptions = getSliderOptions($(".referenzengalerie"));
    $(".referenzengalerie").slick({
        dots: false,
        arrows: refOptions.arrows,
        infinite: true,
        speed: 300,
        autoplay: refOptions.autoplay,
        autoplaySpeed: refOptions.autoplaySpeed,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "40px",
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    function reactivateSlider(slidername) {
        slidername.find(".imageslider").slick({
            dots: false,
            infinite: true,
            adaptiveHeight: true,
            appendArrows: slidername.find(".slidernavigation .slidernavbuttons"),
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ],
        });
        slidername.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
                var newSlideVal = nextSlide + 1;
                if (newSlideVal < 10) {
                    newSlideVal = "0" + newSlideVal;
                }

                slidername.find(".slidernumber .activeSlide").html(newSlideVal);
            }
        );
    }

    reactivateSlider($(".fullwidthslidercontainer"));

    function getSliderOptions(element) {
        const autoScrollSpeed = element.data("autoscroll");
        const hasAutoScroll =
            autoScrollSpeed &&
            autoScrollSpeed !== "" &&
            autoScrollSpeed !== undefined;

        return {
            arrows: Boolean(element.data("arrows")) === true,
            autoplay: hasAutoScroll,
            autoplaySpeed: hasAutoScroll ? autoScrollSpeed : 0,
            slidesToShow: element.data("anzvis") || 2,
        };
    }

    /* zählanimation */
    function counterAnimation(element, speed = 2000) {
        //console.log(element);
        element.find(".zahlbubble").each(function () {
            if ($(this).length > 0) {
                var innerElement = $(this).find("span");
                // init my numberst
                if (!$(this).hasClass("counterInitialized")) {
                    var originalVal = "" + $(this).data("zielzahl");
                    var numberWithoutOtherChar = originalVal.replace(/\D/g, "");

                    var countto = parseInt(numberWithoutOtherChar);
                    var countprepend = "";

                    var countappend =
                        innerElement.slice(-1) != 0 ? innerElement.slice(-1) : "";

                    var appendNotDone = true;
                    var originalValTemp = originalVal;

                    var sicherheitsvariable = 1;

                    while (appendNotDone) {
                        var newChar = "";
                        var newChar = originalValTemp.slice(-sicherheitsvariable);
                        // console.log(originalValTemp);
                        if (isNaN(newChar)) {
                            countappend = newChar;
                        } else {
                            appendNotDone = false;
                        }
                        sicherheitsvariable--;
                        if (sicherheitsvariable >= 100) {
                            appendNotDone = false;
                        }
                    }

                    // console.log($(this));
                    $(this).addClass("counterInitialized");
                    innerElement
                        .data("normalvalue", originalVal)
                        .attr("data-normalvalue", originalVal);
                    innerElement
                        .data("countprepend", countprepend)
                        .attr("data-countprepend", countprepend);
                    innerElement.data("countto", countto).attr("data-countto", countto);
                    innerElement
                        .data("countappend", countappend)
                        .attr("data-countappend", countappend);
                }
            }
            animateValue(innerElement, 0, innerElement.data("countto"), speed);
        });
    }
    //counterAnimation();

    var elsInGroups = $(
        ".entry-content>.wp-block-group>.wp-block-column.is-layout-flow"
    );
    var elsInCols = $(
        ".entry-content>.wp-block-columns>.wp-block-column.is-layout-flow"
    );
    var arrayOfElemns = [];
    arrayOfElemns = addElementsToArr(arrayOfElemns, $(".zahlenunddaten"));
    arrayOfElemns = addElementsToArr(arrayOfElemns, $(".wobblebildeffekt img"));
    arrayOfElemns = addElementsToArr(arrayOfElemns, $(".lustaufeinprojektlink"));
    arrayOfElemns = addElementsToArr(arrayOfElemns, elsInCols);
    arrayOfElemns = addElementsToArr(arrayOfElemns, elsInGroups);
    /*
      for(var i = 0; i < elsInCols.length; i++){
        var nextFreeArrayField = arrayOfElemns.length + i;
        var nextKey = Object.keys(elsInCols)[i];
        arrayOfElemns[nextFreeArrayField] = elsInCols[nextKey];
      }*/
    observeElements(arrayOfElemns, "observerd");

    function addElementsToArr(baseArray, newElements) {
        if (newElements && newElements.length > 0) {
            for (var i = 0; i < newElements.length; i++) {
                var nextFreeArrayField = baseArray.length + i;

                var nextKey = Object.keys(newElements)[i];
                baseArray[nextFreeArrayField] = newElements[nextKey];
            }
        }

        return baseArray;
    }

    function leadingzeros(number, digits) {
        var numberstring = parseInt(number) + "";
        var numberlength = numberstring.length;
        // console.log("numberlength of "+ number + " ist " + numberlength);
        // console.log("anzahl gewünschte digits ist"+ digits);
        if (numberlength < digits) {
            var difference = digits - numberlength;
            for (var i = 0; i < difference; i++) {
                numberstring = "0" + "" + numberstring;
            }
        }
        numberstring = numberstring.toLocaleString();
        return numberstring;
    }

    function animateValue(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            var newNumber = Math.floor(progress * (end - start) + start);
            var numberSize = (obj.data("normalvalue") + "").replace(".", "").length;
            newNumber = addThousandsDots(leadingzeros(newNumber, numberSize));
            obj.html(newNumber);
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    /* definiert die aufrufe aller Animationen */
    function checkForUsedAnimation(element) {
        if (element.classList.contains("zahlenunddaten")) {
            counterAnimation($(".zahlenunddaten"), 3000);
        } else if (element.parentElement.classList.contains("wobblebildeffekt")) {
            element.classList.add("test");
        } else if (element.classList.contains("zahlenunddaten")) {
            //counterAnimation();
        }
    }

    function addThousandsDots(value) {
        var valueString = "" + value;
        var newValue = "";
        var counter = 0;
        for (var i = valueString.length - 1; i >= 0; i--) {
            if (counter >= 3) {
                newValue = "." + newValue;
                counter = 1;
            } else {
                counter++;
            }
            newValue = valueString[i] + newValue;
        }
        return newValue;
    }

    function observeElements(elems, elemClass) {
        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleIntersection, options);
        elems.forEach((elem) => observer.observe(elem));
        function handleIntersection(entries) {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(elemClass);
                    observer.unobserve(entry.target);
                    checkForUsedAnimation(entry.target);
                }
            });
        }
    }

    $(".popuptrigger").on("click", function () {
        $(this).toggleClass("popupopen");
        $(".popup_container").toggleClass("popupopen");
    });

    $(".oeffne_dropdown").on("click", function () {
        $(".popuptrigger").toggleClass("popupopen");
        $(".popup_container").toggleClass("popupopen");
    });

    if ($(".produkte_filter").length) {
        validateFilter();
    }

    $("input[type=radio][name=radiostrom], .maincatcheckbox").change(function () {
        validateFilter();
        // alert(this.value);
    });
    $(".maincatcheckbox").on("click", function () {
        // stellt sicher, dass nur ein anwendungsbereich genutzt werden kann
        // kein radiobutton, weil es eine schnelle Anpassung der vorhandenen Lösung ist.
        var newVal = $(this).prop("checked");
        var changedName = $(this).attr("name");
        $(".maincatcheckbox")
            .not("[name='" + changedName + "']")
            .prop("checked", false);
    });

    function validateFilter(changearr) {
        var stromstatus = $("input[type=radio][name=radiostrom]:checked")[0].value;
        var mainCatsArr = mainCatsCheckedArray();

        $(".produkt_link").each(function () {
            var activeStatus = false;

            var eigenstrom = $(this).data("strom");
            var eigenstromAlways = $(this).data("stromalways");

            if (
                stromstatus == "alle" ||
                eigenstromAlways ||
                (stromstatus == "ja" && eigenstrom == 1) ||
                (stromstatus == "nein" && eigenstrom == 0)
            ) {
                activeStatus = true;
            }

            if (activeStatus && mainCatsArr.length > 0) {
                activeStatus = findAllChoosenCats(mainCatsArr, $(this));
            }

            if (activeStatus) {
                $(this).addClass("active_prod");
            } else {
                $(this).removeClass("active_prod");
            }
        });
    }

    // PRodukte werden in Mobile zum Slider
    /*$(".produkte_aufgelistet").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 458,
            slidesToShow: 1,
          },
          {
            breakpoint: 658,
            slidesToShow: 2,
          },
          {
            breakpoint: 868,
            settings: "unslick",
          },
        ],
      }); */

    function mainCatsCheckedArray() {
        var returnArr = [];
        var arrCounter = 0;
        $(".maincatcheckbox:checked").each(function () {
            returnArr[arrCounter] = $(this).attr("name");
            arrCounter++;
        });

        return returnArr;
    }

    function findAllChoosenCats(catsArr, el) {
        var returnBool = false;
        var elCategoriesString = el.data("categories");
        var elCategoriesArray = elCategoriesString.split(",");
        // console.log(elCategoriesArray);
        for (var i = 0; i < catsArr.length; i++) {
            returnBool = elCategoriesArray.indexOf(catsArr[i]) >= 0;
            // console.log(returnBool);
            if (returnBool == false) {
                break;
            }
        }

        var checkedArray = 0;

        return returnBool;
    }

    function arrContains(a, obj) {
        for (var i = 0; i < a.length; i++) {
            if (a[i] === obj) {
                return true;
            }
        }
        return false;
    }

    $(".seccatscontainertrigger").on("click", function () {
        $(this).toggleClass("activemorekats");
    });

    /* language sprach umschalter */
    $(".current-lang-trigger").on("click", function () {
        $(".drop-block").toggleClass("isopen");
    });

    $(".tabheadline").on("click", function () {
        var tabid = $(this).data("tabelid");
        console.log('.tabcontentelement[data-tabelid="' + tabid + '"]');
        $(this)
            .parents(".tabscontainer")
            .find(".tabopened")
            .each(function () {
                $(this).removeClass("tabopened");
            });
        $(this).addClass("tabopened");
        $('.tabcontentelement[data-tabelid="' + tabid + '"]').addClass("tabopened");
    });

    $(".burger-menu-trigger").on("click", function () {
        $(this).toggleClass("activeBurger");
        $(".menu_base_row>ul").toggleClass("activeMainMenu");
        $(".popupopen").removeClass("popupopen");
    });

    $(".closeProdukteSearch").on("click", function () {
        $(".popupopen").removeClass("popupopen");
    });

    /* start all videos */
    console.log("start all Videos");
    $(".videowithoverlay")
        .find("video")
        .each(function () {
            var autoplaysuccess = $(this).get(0).play();
            console.log("Autoplay: " + autoplaysuccess);
        });

    $(".videowithoverlay:not(.vidisplaying)").on("click", function () {
        $(this)
            .find("video")
            .each(function () {
                var video = $(this).get(0);

                var videoElement = video;

                if (videoElement.paused) {
                    console.log("startPlaying the Video for IOS");
                    videoElement.play();
                }
                $(this).parents(".videowithoverlay").addClass("vidisplaying");
            });
    });

    /* popupimage */
    function clickPopupImage() {
        $(".popupimage").on("click", function () {
            var newImageFigure = $(this).clone().html();
            //https://www.liveye.com/wp-content/webp-express/webp-images/doc-root/wp-content/uploads/2024/01/liveye-perimeter-1024x576.jpg.webp 1024w, https://www.liveye.com/wp-content/webp-express/webp-images/doc-root/wp-content/uploads/2024/01/liveye-perimeter-300x169.jpg.webp 300w, https://www.liveye.com/wp-content/webp-express/webp-images/doc-root/wp-content/uploads/2024/01/liveye-perimeter-768x432.jpg.webp 768w, https://www.liveye.com/wp-content/webp-express/webp-images/doc-root/wp-content/uploads/2024/01/liveye-perimeter.jpg.webp 1280w
            //
            var imgdata = $(this).find("img");
            var srcsetstring = imgdata.attr("srcset");
            var srcsalt = imgdata.attr("alt");
            var srcsclasses = imgdata.attr("class");
            var imagedataalt = srcsalt;
            var imgdataclass = srcsclasses; //alt="Secure by night";
            var onlybigimage = srcsetstring.split(", ").pop().split(" ")[0];
            newImageFigure =
                srcsetstring.length > 0 && srcsetstring != ""
                    ? '<img class="' +
                    imgdataclass +
                    '" alt="' +
                    imagedataalt +
                    '" src="' +
                    onlybigimage +
                    '" />'
                    : newImageFigure;
            $(".popupImageContainer").remove();
            var popupHTML = dynamicPopupTemplate(newImageFigure, "Image");
            $("body").prepend(popupHTML);
        });
    }
    //clickPopupImage();
    $(document).on("click", ".popupclose, .popupCloseIcon", function () {
        $(this).parents(".rdtsPopup").remove();
    });

    if ($(".popupimage").length > 0) {
        clickPopupImage();
    }

    if ($(".fullpageproducts").length > 0) {
        clickPopupProducts();
    }
    function clickPopupProducts() {
        $(".fullpageproducts.haspopupproduct").on(
            "click",
            ".produkt_link.active_prod",
            function () {
                var clickedProdID = $(this).data("prodid");
                var newProduktContent = $(".allprodudctslistet")
                    .find(".productcontentcontainer[data-prodid=" + clickedProdID + "]")
                    .clone();
                $(".popupProduktContainer").remove();
                var popupHTML = dynamicPopupTemplate(
                    newProduktContent.html(),
                    "Produkt"
                );
                $("body").prepend(popupHTML);
            }
        );
    }

    if ($(".serviceformopener").length > 0) {
        serviceOpenPopup();
        serviceClosePopup();
    }

    function serviceOpenPopup() {
        $(".serviceformopener").on("click", function () {
            $(".rueckrufformularpopup").show();
            saveCookieHelper("serviceformcookie", "openend");
        });
    }
    function serviceClosePopup() {
        $(".rueckrufformularpopupclose").on("click", function () {
            $(".rueckrufformularpopup").hide();
            saveCookieHelper("serviceformcookie", "closed");
        });
    }

    if ($(".serviceformopener").length > 0) {
        rueckrufopenPopup();
        rueckrufclosePopup();
        setTimeout(function () {
            var rueckrufstat = readCookieHelper("rueckrufcookie");
            if (rueckrufstat != "closed") {
                $(".rueckrufformularpopup").show();
                $(".rueckrufformularopener").hide();
            }
            console.log("Popup opened");
        }, 30000);
    }
    function rueckrufopenPopup() {
        $(".rueckrufformularopener").on("click", function () {
            $(".rueckrufformularpopup").show();
            $(".rueckrufformularopener").hide();
            saveCookieHelper("rueckrufcookie", "openend");
        });
    }
    function rueckrufclosePopup() {
        $(".rueckrufformularpopupclose").on("click", function () {
            $(".rueckrufformularpopup").hide();
            $(".rueckrufformularopener").show();
            saveCookieHelper("rueckrufcookie", "closed");
        });
    }

    function dynamicPopupTemplate(content, name = "Dynamic") {
        var popupHTML = `
    <div class="popup${name}Container rdtsPopup">
    <div class="popup${name}BG popupBG">
      <div class="popup${name}Content popupcontent">
        ${content}
      </div>
      <div class="popupclose">
        
      </div>
      <i class="popupCloseIcon">+</i>
    </div>      
    </div>
    `;
        return popupHTML;
    }

    function readCookieHelper(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    function saveCookieHelper(name, value, days = 1) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    $("select.wpcf7-form-control.wpcf7-select").each(function () {
        $(this).parent().addClass("selectcontainer");
    });

    /*
      
      .wpcf7-form-control-wrap.selectcontainer{
            width: 100%;
            display: block;
            overflow: hidden;
            border-radius: 200px;
            border: 1px solid black;
            select.wpcf7-form-control.wpcf7-select
      */

    $(document).ready(function () {
        $('a[href^="#"]').on("click", function (e) {
            e.preventDefault();

            var target = this.hash;
            var $target = $(target);

            $("html, body")
                .stop()
                .animate(
                    {
                        scrollTop: $target.offset().top,
                    },
                    900,
                    "swing",
                    function () {
                        window.location.hash = target;
                    }
                );
        });
    });

    $("#btn_phase1").on("click", function () {
        $(".form_box_phase1_container").hide();
        $(".form_box_phase2_container").show();
        /* creates random string for identification */
        var randomString = generateRandomString(20);
        $('span[data-name="reg_perm"] input[type="text"]').val(randomString);

        /* creates current-url field */
        $('span[data-name="currurl"] input[type="text"]').val(
            window.location.protocol +
            "//" +
            window.location.hostname +
            window.location.pathname
        );
    });

    /* Kontaktnummerselection */
    $(".dropdown_langs_land").on("click", function () {
        console.log("triggered lang-nummer dropdown");
        var liveland = $(".live_land").data("landid");
        $(".dropel_land").removeClass("hidden");
        var dropel_land = $(
            '.dropel_land[data-landid="' + liveland + '"]'
        ).addClass("hidden");
        $(".dropdownlaendernumbers").toggleClass("active");
    });
    $(".dropel_land").on("click", function () {
        var selectedLand = $(this).data("landid");
        var htmlContent = $(this).html();
        $(".live_land")
            .data("landid", selectedLand)
            .attr("data-landid", selectedLand);

        $(".live_land").html(htmlContent);
        $(".dropdownlaendernumbers").removeClass("active");
        console.log("selected land is: " + selectedLand);
    });

    $(".popinphonenumbers").on("click", function () {
        $(this).fadeOut();
    });
    $(".multipleapossiblenumbers").on("click", function (e) {
        e.preventDefault();
        $(".popinphonenumbers").fadeToggle();
    });

    $(".dropdown_menu").on("click", ".dropdownmentoggler", function () {
        $(this).toggleClass("active");
    });

    //$('.debugger_footer_trigger').on('click',function(){
    var movespeed =
        $(".footerpartnerlinks").data("movespeed") &&
            $(".footerpartnerlinks").data("movespeed").length > 0
            ? $(".footerpartnerlinks").data("movespeed")
            : 5000;
    $(".footerpartnerlinks").slick({
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        speed: movespeed,
        slidesToShow: 7,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        arrows: false,
    });
    //});
});
